/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'name',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.name}>
          {rowData.name}
        </span>
      ),
    },
    { title: t('general.start-time'), field: 'startTime' },
    { title: t('general.final-time'), field: t('endTime') },
    {
      title: t('general.url-camera'),
      field: 'url',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.url}>
          {rowData.url}
        </span>
      ),
    },
  ];
}
